import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { Icon, Dropdown } from 'semantic-ui-react';
import classes from './WeekSelector.css';
import { MOBILE } from '../../../../../store/actions/browser.types';


const AngleIcon = () => (
  <Icon fitted name="angle down" className={classes.angleDown} />
);

class WeekSelector extends PureComponent {

  static propTypes = {
    onChangeWeek: PT.func.isRequired,
    weeks: PT.arrayOf(PT.number).isRequired,
    mediaType: PT.string.isRequired,
    currentWeek: PT.number.isRequired,
  };

  static defaultProps = {
    onChangeWeek: () => true,
    weeks: [],
    currentWeek: 0,
  }

  render() {
    const { weeks, onChangeWeek, mediaType, currentWeek } = this.props;
    if (mediaType !== MOBILE) {
      return (
        <ul className={classes.weekSelectorDesktop}>
          {weeks.map(weekNum =>
            <li
              key={weekNum}
              onClick={onChangeWeek}
              value={weekNum}
              className={weekNum === currentWeek ? classes.selected : ''}
            >
              {weekNum === 0 ? 'All' : weekNum}
            </li>)}
        </ul>
      );
    }
    const mobileOptions = weeks.map(weekNumber => ({
      key: weekNumber,
      text: weekNumber === 0 ? 'All' : weekNumber,
      value: weekNumber,
    }));
    return (
      <Dropdown
        className={classes.weekSelectorMobile}
        compact
        scrolling
        defaultValue={currentWeek}
        options={mobileOptions}
        onChange={onChangeWeek}
        icon={<AngleIcon />}
      />
    );
  }
}

export default WeekSelector;



// WEBPACK FOOTER //
// ./src/app/components/TableControls/JumpToWeek/WeekSelector/WeekSelector.js